import { render, staticRenderFns } from "./FundingView.vue?vue&type=template&id=490654dc&"
import script from "./FundingView.vue?vue&type=script&lang=js&"
export * from "./FundingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports